import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faAngleLeft, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';

function ReferralBar({referralBar, toggleReferralBar }) {
  const { user } = useUser();
  const [referralhistory, setReferralhistory] = useState([
  ]);
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  useEffect(() => {
    const fetchReferral = async () => {
      try {
        const myCopyRes = await fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ fetchReferral: true })
        });
        const allreff = await myCopyRes.json();
        if (allreff.status !== "success") {
          return;
        }
        const allrefferral = allreff.allreff;
        setReferralhistory(allrefferral);
      } catch (err) {
      }
    };
    if (user) {
      fetchReferral();
    }
  }, [user]);

  const [address, setAddress] = useState(user?.referralID);
  const [refBal, setRefBal] = useState(user?.bonus);
  const handleCopy = async () => {
    if (!address) return;
    try {
        await navigator.clipboard.writeText(address);
        toast.success('Copied to Clipboard!')
    } catch (err) {
        console.error("Failed to copy: ", err);
    }
  };
  const [searchTerm, setSearchTerm] = useState('');
  const filteredReferral = referralhistory.filter(filteredAsset => 
    Object.values(filteredAsset).some(value => 
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  )
  const claimReward = async () => {
    if (refBal <= 0) {
      toast.error('You have no bonus to claim.');
      return;
    }
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ claimReward: true })
      });
      const data = await response.json();
      if (data.status !== "success") {
        toast.error(data.message);
        return;
      }
      setRefBal(0);
      toast.success('Reward claimed successfully!');
    } catch (err) {
    }
  };
    return (
      <div className={`notifybar ${referralBar ? "active" : null}`}>
          <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center" style={{cursor: 'pointer'}}>
                  <FontAwesomeIcon icon={faAngleLeft} style={{color: 'white', cursor: 'pointer', fontSize: '14px'}} onClick={() => {toggleReferralBar()}}/>
                  <p className="mb-0 fw-semibold ms-3 text-white">Referral program</p>
              </div>
              <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '20px'}} onClick={() => {toggleReferralBar()}}/>
          </div>
          <div className="sidebar-navbar" style={{height: 'auto'}}>
              <p className="fw-bold text-secondary" style={{fontSize: '13px'}}>Invite your friends to join our platform by using your referral code on sign up! You'll earn $6,000.00 anytime your friends make a deposit on our platform. It's a win-win for everyone!</p>
              <label className="fw-semibold my-2" style={{fontSize: '14px'}}>Your referral balance:</label>
              <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                <div className="d-flex align-items-center">
                  <span className="fw-semibold">{getCurrencySymbol(user?.currency)}</span>
                  <input 
                    type="text"
                    className="inputNone"
                    readOnly
                    value={formatCurrency(refBal * rate)}
                    onChange={(e) => setRefBal(e.target.value)}
                  />
                </div>
                <div className="fw-bold text-white" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}} onClick={claimReward}>CLAIM</div>
              </div>
              <label className="fw-semibold mb-2 mt-3" style={{fontSize: '14px'}}>Your referral code:</label>
              <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                <input 
                  type="text"
                  readOnly
                  className="inputNone"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
                <div className="fw-bold text-white" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}} onClick={handleCopy}>COPY</div>
              </div>
              <p className="mt-5 fw-bold text-secondary mb-0" style={{fontSize: '14px'}}>Statistics</p>
              <div className="d-flex align-items-center mt-4" style={{gap: '16px'}}>
                <div>
                  <p className="fw-bold text-secondary mb-0" style={{fontSize: '14px'}}>Friends invited</p>
                  <h5 className="mb-0 fw-bold text-white">{referralhistory.length}</h5>
                </div>
              </div>
              <p className="mt-5 fw-bold text-secondary mb-3" style={{fontSize: '14px'}}>Referrals</p>
              <div className="d-flex align-items-center form-control justify-content-between searchcon">
                <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                <input 
                type="text" 
                placeholder="Search for a referral" 
                className="searchinput"
                value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
              />
              </div>
              {filteredReferral.length > 0 ? (
                filteredReferral.map((ref, key) => (
                  <div className="table-responsive scrollDown" key={key}>
                    <table className="table table-hover table-striped table-hover table-borderless table-dark align-middle">
                      <thead>
                          <tr className="fs-7">
                              <th className="fw-normal text-light">ID</th>
                              <th className="fw-normal text-light">Fullname</th>
                              <th className="fw-normal text-light">Email</th>
                          </tr>
                      </thead>
                      <tbody style={{fontSize: '14px'}}>
                        <tr>
                            <td>{key + 1}</td>
                            <td>{ref.fullname}</td>
                            <td>{ref.email}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ))
              ) : (
              <div className="sidebar-navbar">
                <div className="d-flex align-items-center flex-column justify-content-center w-100 h-100" style={{gap: '16px', color: 'rgba(255, 255, 255, 0.65)'}}>
                    <svg style={{width: '40px', height: '40px'}} className="svg-icon" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.132 6.06h10" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.352 2.5h5.56c1.78 0 2.22.44 2.22 2.2v4.11c0 1.76-.44 2.2-2.22 2.2h-5.56c-1.78 0-2.22-.44-2.22-2.2V4.7c0-1.76.44-2.2 2.22-2.2Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.132 17.56h10" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.352 14h5.56c1.78 0 2.22.44 2.22 2.2v4.11c0 1.76-.44 2.2-2.22 2.2h-5.56c-1.78 0-2.22-.44-2.22-2.2V16.2c0-1.76.44-2.2 2.22-2.2ZM22.132 15.5c0 3.87-3.13 7-7 7l1.05-1.75" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.05 4.1 3.738 7.414M3.732 4.1l3.314 3.314" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"></path></svg>
                    <p className=" mb-0 fw-semibold">No referrals yet.</p>
                </div>
              </div>
              )}
          </div>
      </div>
    )
}

export default ReferralBar